module.exports = __webpack_public_path__ + "static/icons/icon-ski-hire--black-99e08c68a4c18c90f610f3cbd0adf9e5.svg";